import React, { useState, useEffect, useContext, useMemo } from "react";
import AdminContext from "../../StateContext/Application";
import { jwtDecode } from "jwt-decode";
import { useLanguage } from "../../../../lang/langcontext/LanguageContext";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import GooglePagination from "../../styles/GooglePagination";
import { filterStyle,filterWrapperStyle } from '../../styles/filterStyles';

const WorkStatusReport = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const context = useContext(AdminContext);
  const { GetBudgetHeadInfo, GetWorkStatusReportData } = context;

  const [loading, setloading] = useState(false);
  const [userData, setUserData] = useState(null);
  const [reportData, setReportData] = useState([]);
  const [exportingPDF, setExportingPDF] = useState(false);

  // Data Lists
  const [headCodeList, setHeadCodeList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [talukaList, setTalukaList] = useState([]);

  console.log("headCodeList: ", headCodeList);
  console.log("districtList: ", districtList);
  console.log("talukaList: ", talukaList);
  console.log("reportData: ", reportData);

  // Selections
  const [selectedHeadCode, setSelectedHeadCode] = useState("");
  const [selectedDist, setSelectedDist] = useState("");
  const [selectedTaluka, setSelectedTaluka] = useState("");
  const [selectedYear, setSelectedYear] = useState("");

  // 1. Add/Update these states at the top of your component
  const [SelectedDistrict, setSelectedDistrict] = useState([]); // Array for multiple districts
  const [openDistrict, setOpenDistrict] = useState(false);
  const [AllDistrict, setAllDistrict] = useState([]); // This will store the full district objects
  const [searchTerm, setSearchTerm] = useState("");
  useEffect(() => {
    const token = localStorage.getItem("Token");
    if (token) {
      try {
        // Decode the JWT token to get user details
        const decoded = jwtDecode(token);
        setUserData(decoded);
        console.log("Logged User Info:", decoded);
      } catch (error) {
        console.error("Invalid token:", error);
      }
    }
  }, []);

  console.log("userData: ", userData);

  // 1. Fetch Head Codes with Role Filtering
  useEffect(() => {
    const fetchHeads = async () => {
      try {
        const res = await GetBudgetHeadInfo("null", "AllHeadCode");
        const restrictedRoles = [
          "State-2515-RDD Checker(ASO)",
          "State-2515-RDD Section Officer",
        ];

        if (restrictedRoles.includes(userData?.FullName)) {
          // Auto-filter and select for MLA Representative
          const mlaHead = res.filter((h) => h.HeadName.includes("2515-1238"));
          setHeadCodeList(mlaHead);
          if (mlaHead.length > 0) setSelectedHeadCode(mlaHead[0].HeadID);
        } else {
          setHeadCodeList(
            res.sort((a, b) => new Date(a.Date) - new Date(b.Date)),
          );
        }
      } catch (err) {
        console.error("HeadCode Fetch Error:", err);
      }
    };
    fetchHeads();
  }, []);

  // 2. Fetch All Districts
  // useEffect(() => {
  //   const fetchDistricts = async () => {
  //     try {
  //       const res = await GetBudgetHeadInfo("null", "AllDistrict");
  //       // Get unique districts from the ulb table result
  //       const uniqueDistricts = [
  //         ...new Set(res.map((item) => item.District_Marathi)),
  //       ].filter(Boolean);
  //       setDistrictList(uniqueDistricts);
  //       setAllDistrict(uniqueDistricts);
  //     } catch (err) {
  //       console.error(err);
  //     }
  //   };
  //   fetchDistricts();
  // }, []);

  // 3. Fetch Talukas only when EXACTLY one District is selected
  // useEffect(() => {
  //   const fetchTalukas = async () => {
  //     // Only fetch if there is exactly one district in the array
  //     if (SelectedDistrict.length !== 1) {
  //       setTalukaList([]);
  //       setSelectedTaluka(""); // Clear selected taluka if multiple or zero districts
  //       return;
  //     }

  //     try {
  //       setloading(true);
  //       // Pass the single selected district string from the array
  //       const res = await GetBudgetHeadInfo(
  //         { District: SelectedDistrict[0] },
  //         "GetTalukasForWork",
  //       );
  //       setTalukaList(res);
  //     } catch (err) {
  //       console.error("Taluka Fetch Error:", err);
  //     } finally {
  //       setloading(false);
  //     }
  //   };

  //   fetchTalukas();
  // }, [SelectedDistrict]); // Dependency is now the array

       // keep BOTH raw and consolidated lists
  const [rawDistrictList, setRawDistrictList] = useState([]); 
  
  useEffect(() => {
      const fetchDistricts = async () => {
          try {
              const res = await GetBudgetHeadInfo('null', "AllDistrict");
  
              const rawNames = [
                  ...new Set(res.map(item => item.District_Marathi).filter(Boolean))
              ];
              setRawDistrictList(rawNames);
  
              const uniqueDistricts = [
                  ...new Set(
                      rawNames.map(name => name.split("-")[0]?.trim()).filter(Boolean)
                  )
              ];
              setDistrictList(uniqueDistricts);
              setAllDistrict(uniqueDistricts);
          } catch (err) { console.error(err); }
      };
      fetchDistricts();
  }, []);
  
      // 3. Fetch Talukas only when EXACTLY one District is selected
    useEffect(() => {
      const fetchTalukas = async () => {
          if (SelectedDistrict.length === 0) {
              setTalukaList([]);
              setSelectedTaluka("");
              return;
          }
  
          try {
              setloading(true);
  
              const results = await Promise.all(
                  SelectedDistrict.map((district) =>
                      GetBudgetHeadInfo({ District: district }, "GetTalukasForWork")
                  )
              );
  
              // Merge and de-duplicate talukas across all selected districts
              const merged = results.flat().filter(Boolean);
              const uniqueTalukas = Array.from(
                  new Map(
                      merged.map((t) => [t.ULBNameMarathi, t])
                  ).values()
              );
  
              setTalukaList(uniqueTalukas);
          } catch (err) {
              console.error("Taluka Fetch Error:", err);
          } finally {
              setloading(false);
          }
      };
  
      fetchTalukas();
  }, [SelectedDistrict]);
  

  const filteredHeadCodes = useMemo(() => {
    const roleHeadMap = {
      "State-2515-RDD Checker(ASO)": ["2515-1238(MLA Representative)"],
      "State-2515-RDD Section Officer": ["2515-1238(MLA Representative)"],

      "State-RDD Checker(ASO)": [
        "3054-2419(Roads and bridge repair maintenance program)",
      ],
      "State-RDD Section Officer": [
        "3054-2419(Roads and bridge repair maintenance program)",
      ],

      "State-Deputy Secretary": [
        "3054-2419(Roads and bridge repair maintenance program)",
        "2515-1238(MLA Representative)",
      ],
    };

    const allowedHeads = roleHeadMap[userData?.FullName];

    if (allowedHeads) {
      return headCodeList.filter((val) => allowedHeads.includes(val.HeadName));
    }

    return headCodeList;
  }, [userData, headCodeList]);


  const expandedDistricts = useMemo(() => {
      if (!SelectedDistrict?.length) return [];
  
      return rawDistrictList.filter((raw) =>
          SelectedDistrict.some(
              (district) => raw === district || raw.startsWith(`${district}-`)
          )
      );
  }, [SelectedDistrict, rawDistrictList]);

  useEffect(() => {
    if (!filteredHeadCodes?.length) return;

    const role = userData?.FullName;

    // Roles that must auto-select single option
    const autoSelectRoles = [
      "State-2515-RDD Checker(ASO)",
      "State-2515-RDD Section Officer",
      "State-RDD Checker(ASO)",
      "State-RDD Section Officer",
    ];

    // Default selection for Deputy Secretary
    if (
      role !== "State-2515-RDD Checker(ASO)" &&
      role !== "State-2515-RDD Section Officer"
    ) {
      const defaultHead = filteredHeadCodes.find(
        (h) =>
          h.HeadName ===
          "3054-2419(Roads and bridge repair maintenance program)",
      );

      if (defaultHead && !selectedHeadCode) {
        setSelectedHeadCode(defaultHead.HeadID);
      }
      return;
    }

    // Auto select when only one option
    if (autoSelectRoles.includes(role) && filteredHeadCodes.length === 1) {
      setSelectedHeadCode(filteredHeadCodes[0].HeadID);
    }
  }, [filteredHeadCodes, userData]);

  // 3. Helper functions for Multi-Select
  const handleDistrictToggle = (district) => {
    setSelectedDistrict((prev) => {
      const newSelection = prev.includes(district)
        ? prev.filter((d) => d !== district)
        : [...prev, district];

      // Reset Taluka if selection changes
      setSelectedTaluka("");
      return newSelection;
    });
  };

  const toggleAllDistricts = () => {
    if (SelectedDistrict.length === districtList.length) {
      setSelectedDistrict([]);
    } else {
      setSelectedDistrict([...districtList]);
    }
    setSelectedTaluka("");
  };

  const isAllSelected =
    SelectedDistrict.length === districtList.length && districtList.length > 0;

  // useEffect(() => {
  //   if (!selectedHeadCode) return;

  //   const fetchReport = async () => {
  //     setloading(true);
  //     try {
  //       const data = await GetWorkStatusReportData(
  //         selectedHeadCode,
  //         SelectedDistrict,
  //         selectedTaluka,
  //         selectedYear,
  //       );

  //       setReportData(data);
  //     } catch (error) {
  //       console.error("Error in fetchReport :", error);
  //     } finally {
  //       setloading(false);
  //     }
  //   };

  //   fetchReport();
  // }, [selectedHeadCode, SelectedDistrict, selectedTaluka, selectedYear]);

  useEffect(() => {
      if (!selectedHeadCode) return;
  
      const fetchReport = async () => {
          setloading(true);
          try {
              const data = await GetWorkStatusReportData(
                  selectedHeadCode,
                  expandedDistricts,
                  selectedTaluka,
                  selectedYear
              );
  
              setReportData(data);
          } catch (error) {
              console.error("Error in fetchReport :", error);
          } finally {
              setloading(false);
          }
      };
  
      fetchReport();
  
  }, [selectedHeadCode, expandedDistricts, selectedTaluka, selectedYear]);

  const filteredReportData = useMemo(() => {
    if (!searchTerm.trim()) {
      return reportData;
    }

    const lowerSearchTerm = searchTerm.toLowerCase().trim();

    return reportData.filter((row) =>
      Object.values(row).some((value) =>
        String(value ?? "")
          .toLowerCase()
          .includes(lowerSearchTerm),
      ),
    );
  }, [reportData, searchTerm]);
  // PAGINATION
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;

  const currentData = filteredReportData?.slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil(filteredReportData?.length / itemsPerPage);

  const exportTableByClassToExcel = async (
    filteredBills,
    filename = "Work_Status_Report.xlsx",
  ) => {
    if (!Array.isArray(filteredBills) || filteredBills.length === 0) {
      alert("No data available");
      return;
    }
    setloading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    try {
      const excelData = filteredBills.map((row, index) => {
        return {
          "Sr No": index + 1,
          District: row.District || "-",
          Taluka: row.Taluka || "-",

          "Total Works No": row.TotalWorksCount || 0,
          "Total Works Amount": row.TotalWorksAmt || 0,

          "Total GR Works No": row.GRCount || 0,
          "Total GR Works Amount": row.GRAmt || 0,

          "Total TS Works No": row.TSCount || 0,
          "Total TS Works Amount": row.TSAmt || 0,

          "Total TS No WO No": row.TSNoWOCount || 0,
          "Total TS No WO Amount": row.TSNoWOAmt || 0,

          "Total WO Issued No": row.WOCount || 0,
          "Total WO Issued Amount": row.WOAmt || 0,

          "Total 30% Progress No": row.Prog30Count || 0,
          "Total 30% Progress Amount": row.Prog30Amt || 0,

          "Total 50% Progress No": row.Prog50Count || 0,
          "Total 50% Progress Amount": row.Prog50Amt || 0,

          "Total 100% Progress No": row.Prog100Count || 0,
          "Total 100% Progress Amount": row.Prog100Amt || 0,

          "Total Payments Released No": row.PayCount || 0,
          "Total Payments Released Amount": row.PayAmt || 0,

          "Total Balanace Liability No": row.NotPayCount || 0,
          "Total Balanace Liability Amount": row.NotPayAmt || 0,
        };
      });

      const worksheet = XLSX.utils.json_to_sheet(excelData);

      /* ---- COLUMN WIDTH ---- */
      worksheet["!cols"] = Object.keys(excelData[0]).map(() => ({ wch: 22 }));

      /* ---- FREEZE HEADER ---- */
      worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };

      /* ---- AUTOFILTER (exclude total row) ---- */
      worksheet["!autofilter"] = {
        ref: XLSX.utils.encode_range({
          s: { r: 0, c: 0 },
          e: {
            r: excelData.length - 2,
            c: Object.keys(excelData[0]).length - 1,
          },
        }),
      };

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Work Status Report");

      XLSX.writeFile(workbook, filename);
    } catch (error) {
      console.error("Excel Export Error:", error);
    } finally {
      setloading(false); // ✅ ALWAYS stop loader
    }
  };

  const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
    const CHUNK_SIZE = 500; // change if needed (300–500 ideal)

    setExportingPDF(true);
    setloading(true);

    // 🔥 Allow loader to render
    await new Promise((resolve) => setTimeout(resolve, 600));

    const originalTable = document.querySelector(`.${tableClass}`);
    if (!originalTable) {
      setExportingPDF(false);
      setloading(false);
      return;
    }

    try {
      const originalRows = originalTable.querySelectorAll("tbody tr");
      const totalRows = originalRows.length;

      for (let start = 0; start < totalRows; start += CHUNK_SIZE) {
        const end = Math.min(start + CHUNK_SIZE, totalRows);

        // 🔥 Clone only current chunk
        const table = originalTable.cloneNode(true);
        const rows = table.querySelectorAll("tbody tr");

        rows.forEach((row, index) => {
          if (index < start || index >= end) {
            row.remove();
          }
        });

        document.body.appendChild(table);

        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const topMargin = 25;
        const sideMargin = 10;
        const bottomMargin = 15;

        pdf.setFontSize(16);
        pdf.setFont("helvetica", "bold");
        pdf.text(`${title} (${start + 1} - ${end})`, pageWidth / 2, 15, {
          align: "center",
        });

        const canvas = await html2canvas(table, {
          scale: 1,
          useCORS: true,
          backgroundColor: "#2C78DB",
        });

        const imgWidth = pageWidth - sideMargin * 2;
        const pxToMm = imgWidth / canvas.width;

        const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
        const usablePageHeightPx = usablePageHeightMm / pxToMm;

        let renderedHeight = 0;
        let pageNumber = 0;

        while (renderedHeight < canvas.height) {
          const sliceHeight = Math.min(
            usablePageHeightPx,
            canvas.height - renderedHeight,
          );

          const pageCanvas = document.createElement("canvas");
          const context = pageCanvas.getContext("2d");

          pageCanvas.width = canvas.width;
          pageCanvas.height = sliceHeight;

          context.drawImage(
            canvas,
            0,
            renderedHeight,
            canvas.width,
            sliceHeight,
            0,
            0,
            canvas.width,
            sliceHeight,
          );

          const imgData = pageCanvas.toDataURL("image/jpeg", 0.85);

          if (pageNumber > 0) pdf.addPage();

          pdf.addImage(
            imgData,
            "JPEG",
            sideMargin,
            topMargin,
            imgWidth,
            sliceHeight * pxToMm,
          );

          renderedHeight += sliceHeight;
          pageNumber++;
        }

        pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);

        document.body.removeChild(table);

        // 🔥 Small delay between chunks (prevents freeze)
        await new Promise((resolve) => setTimeout(resolve, 300));
      }
    } catch (error) {
      console.error("PDF Export Error:", error);
    } finally {
      setExportingPDF(false);
      setloading(false);
    }
  };

  // PAGE TOTALS (Current Page)
  const pageTotalWorksAmt = currentData.reduce(
    (s, r) => s + Number(r.TotalWorksAmt || 0),
    0,
  );
  const pageGRAmt = currentData.reduce((s, r) => s + Number(r.GRAmt || 0), 0);
  const pageTSAmt = currentData.reduce((s, r) => s + Number(r.TSAmt || 0), 0);
  const pageTSNoWOAmt = currentData.reduce(
    (s, r) => s + Number(r.TSNoWOAmt || 0),
    0,
  );
  const pageWOAmt = currentData.reduce((s, r) => s + Number(r.WOAmt || 0), 0);

  const pageProg30Amt = currentData.reduce(
    (s, r) => s + Number(r.Prog30Amt || 0),
    0,
  );
  const pageProg50Amt = currentData.reduce(
    (s, r) => s + Number(r.Prog50Amt || 0),
    0,
  );
  const pageProg100Amt = currentData.reduce(
    (s, r) => s + Number(r.Prog100Amt || 0),
    0,
  );

  const pagePayAmt = currentData.reduce((s, r) => s + Number(r.PayAmt || 0), 0);
  const pageNotPayAmt = currentData.reduce(
    (s, r) => s + Number(r.NotPayAmt || 0),
    0,
  );

  // GROSS TOTALS (All Records)
  const grossTotalWorksAmt = reportData.reduce(
    (s, r) => s + Number(r.TotalWorksAmt || 0),
    0,
  );
  const grossGRAmt = reportData.reduce((s, r) => s + Number(r.GRAmt || 0), 0);
  const grossTSAmt = reportData.reduce((s, r) => s + Number(r.TSAmt || 0), 0);
  const grossTSNoWOAmt = reportData.reduce(
    (s, r) => s + Number(r.TSNoWOAmt || 0),
    0,
  );
  const grossWOAmt = reportData.reduce((s, r) => s + Number(r.WOAmt || 0), 0);

  const grossProg30Amt = reportData.reduce(
    (s, r) => s + Number(r.Prog30Amt || 0),
    0,
  );
  const grossProg50Amt = reportData.reduce(
    (s, r) => s + Number(r.Prog50Amt || 0),
    0,
  );
  const grossProg100Amt = reportData.reduce(
    (s, r) => s + Number(r.Prog100Amt || 0),
    0,
  );

  const grossPayAmt = reportData.reduce((s, r) => s + Number(r.PayAmt || 0), 0);
  const grossNotPayAmt = reportData.reduce(
    (s, r) => s + Number(r.NotPayAmt || 0),
    0,
  );

  return (
    <>
      <div
        className="col-12 pb-5"
        style={{
          backgroundColor: "#EFF3F8",
          height: "90vh",
          overflowX: "hidden",
          overflowY: "scroll",
          position: "relative",
        }}
      >
        <div
          style={{
            filter: loading ? "blur(4px)" : "none",
            pointerEvents: loading ? "none" : "auto",
            transition: "0.2s ease",
          }}
        >
          <div className="col-11 m-auto">
            <div
              className="col-12 px-4 mb-4 mt-3"
              style={{
                filter: loading ? "blur(4px)" : "none",
                pointerEvents: loading ? "none" : "auto",
                transition: "0.2s ease",
              }}
            >
              {/* ================= ROW 1 : HEADING + DOWNLOAD ================= */}
              <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                <h5 className="fw-bold d-flex align-items-center m-0">
                  <img
                    src="/Work-Order-Outwards-Blue64.png"
                    alt="Proposal Report"
                    style={{
                      width: "24px",
                      height: "24px",
                      marginRight: "6px",
                    }}
                  />
                  {t("Work Status Report")}
                </h5>

                <div className="d-flex gap-2">
                  <button
                    className="btn btn-success"
                    onClick={() =>
                      exportTableByClassToExcel(
                        reportData,
                        "Work_Status_Report.xlsx",
                      )
                    }
                  >
                    {t("Download Excel")}
                  </button>

                  <button
                    className="btn btn-danger"
                    onClick={() =>
                      downloadTableOnlyAsPDF(
                        "ProposalstatusReport",
                        "Work_Status_Report.pdf",
                        "Work Status Report",
                      )
                    }
                  >
                    {t("Download PDF")}
                  </button>
                </div>
              </div>

              {/* ================= ROW 2 : FILTERS + SEARCH ================= */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  flexWrap: "nowrap",
                }}
              >
                {/* Choose headcode */}
                <div style={filterWrapperStyle}>
                  <select
                    value={selectedHeadCode}
                    onChange={(e) => { setSelectedHeadCode(e.target.value); setSelectedDistrict([]); setSelectedTaluka(''); }}
                    style={filterStyle}
                  >
                    <option value="null" disabled>{t("Choose Head Code")}</option>
                    {filteredHeadCodes && filteredHeadCodes.map((val, index) => (
                      <option key={index} value={val.HeadID}>{val.HeadName}</option>
                    ))}
                  </select>
                </div>

                {/* Multi-Select District */}
                <div style={filterWrapperStyle}>
                  <div
                    onClick={() => setOpenDistrict(!openDistrict)}
                    style={{ ...filterStyle, cursor: "pointer", display: "flex", alignItems: "center" }}
                  >
                    {SelectedDistrict.length > 0 ? SelectedDistrict.join(", ") : t("Select District")}
                  </div>

                  {openDistrict && (
                    <div style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      width: "100%",
                      background: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                      zIndex: 9999,
                    }}>
                      <label style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "6px 8px",
                        borderBottom: "1px solid #eee",
                        cursor: "pointer",
                        fontSize: "13px",
                      }}>
                        <input type="checkbox" checked={isAllSelected} onChange={toggleAllDistricts} style={{ marginRight: "6px" }} />
                        {t("All Districts")}
                      </label>
                      <div style={{ maxHeight: "150px", overflowY: "auto" }}>
                        {districtList.map((dist, index) => (
                          <label key={index} style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "6px 8px",
                            cursor: "pointer",
                            fontSize: "13px",
                          }}>
                            <input
                              type="checkbox"
                              checked={SelectedDistrict.includes(dist)}
                              onChange={() => handleDistrictToggle(dist)}
                              style={{ marginRight: "6px" }}
                            />
                            {dist}
                          </label>
                        ))}
                      </div>
                      <div style={{
                        borderTop: "1px solid #eee",
                        padding: "6px",
                        textAlign: "right",
                      }}>
                        <button
                          onClick={() => setOpenDistrict(false)}
                          style={{
                            padding: "4px 10px",
                            fontSize: "12px",
                            borderRadius: "6px",
                            border: "none",
                            background: "#0d6efd",
                            color: "#fff",
                            cursor: "pointer",
                          }}>OK</button>
                      </div>
                    </div>
                  )}
                </div>

                {/* Taluka */}
                <div style={filterWrapperStyle}>
                  <select
                    value={selectedTaluka}
                    onChange={(e) => setSelectedTaluka(e.target.value)}
                    style={filterStyle}
                  >
                    <option value="">{t("Select Taluka")}</option>
                    {talukaList?.map((val, index) => (
                      <option key={index} value={val.ULBNameMarathi}>
                        {val.ULBNameMarathi}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Year */}
                <div style={filterWrapperStyle}>
                  <select
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                    style={filterStyle}
                  >
                    <option value="">{t("Select Year")}</option>
                    <option value="2024-2025">2024-2025</option>
                    <option value="2025-2026">2025-2026</option>
                    <option value="2026-2027">2026-2027</option>
                  </select>
                </div>
              </div>
            </div>

            {/* TABLE CARD */}
            <div className="col-12 pb-5">
              <div
                className="m-auto mb-3"
                style={{
                  backgroundColor: "white",
                  padding: "40px 40px",
                  boxShadow: "0px 0px 5px 1px #E4E8EC",
                  borderRadius: "20px",
                }}
              >
                <div
                  className="col-12 tableDesign"
                  style={{
                    background: "#2C78DB",
                  overflowX: "auto",
                      overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative",
                    maxWidth: "100%",
                  }}
                >
                  <table
                    className="m-0 p-0 ProposalstatusReport"
                    style={{
                      width: "max-content",
                      minWidth: "1600px",
                      borderCollapse: "collapse",
                    }}
                  >
                    <thead style={{ position: "sticky",  backgroundColor: "#1976d2",
                      top: 0,
                      zIndex: 10,}}>
                      {/* LEVEL 1: Main Categories */}
                      <tr
                        style={{
                          color: "white",
                          border: "none",
                          height: "3rem",
                          fontSize: "18px",
                          fontWeight: "400",
                        }}
                      >
                        <th style={{ minWidth: "80px" }} rowSpan="3">
                          Sr No
                        </th>
                        <th style={{ minWidth: "160px" }} rowSpan="3">
                          District
                        </th>
                        <th style={{ minWidth: "160px" }} rowSpan="3">
                          Taluka
                        </th>
                        <th colSpan="2" rowSpan="2">
                          Total Works
                        </th>
                        <th colSpan="2" rowSpan="2">
                          GR Sanctioned
                        </th>
                        <th colSpan="2" rowSpan="2">
                          Technical Sanctioned
                        </th>
                        <th colSpan="2" rowSpan="2">
                          TS but No WO
                        </th>
                        <th colSpan="2" rowSpan="2">
                          WO Issued
                        </th>

                        {/* PHYSICAL PROGRESS TOP PARENT */}
                        <th
                          colSpan="6"
                          style={{
                            borderLeft: "1px solid #fff",
                            textAlign: "center",
                          }}
                        >
                          Physical Progress
                        </th>

                        <th colSpan="2" rowSpan="2">
                          Payments Released
                        </th>
                        <th colSpan="2" rowSpan="2">
                          Balance Liability
                        </th>
                      </tr>

                      {/* LEVEL 2: Progress Percentages */}
                      <tr
                        style={{
                          color: "white",
                          border: "none",
                          height: "3rem",
                          fontSize: "18px",
                          fontWeight: "400",
                        }}
                      >
                        <th
                          colSpan="2"
                          style={{ borderLeft: "1px solid #fff" }}
                        >
                          30% Progress
                        </th>
                        <th
                          colSpan="2"
                          style={{ borderLeft: "1px solid #fff" }}
                        >
                          50% Progress
                        </th>
                        <th
                          colSpan="2"
                          style={{ borderLeft: "1px solid #fff" }}
                        >
                          100% Progress
                        </th>
                      </tr>

                      {/* LEVEL 3: Final Sub-headers (No. / Amount) */}
                      <tr
                        style={{
                          color: "white",
                          border: "none",
                          height: "3rem",
                          fontSize: "18px",
                          fontWeight: "400",
                        }}
                      >
                        {/* Sub-headers for the first 5 groups */}
                        <th style={{ borderLeft: "1px solid #fff" }}>
                          Total No.
                        </th>
                        <th>Total Amount</th>
                        <th style={{ borderLeft: "1px solid #fff" }}>
                          Total No.
                        </th>
                        <th>Total Amount</th>
                        <th style={{ borderLeft: "1px solid #fff" }}>
                          Total No.
                        </th>
                        <th>Total Amount</th>
                        <th style={{ borderLeft: "1px solid #fff" }}>
                          Total No.
                        </th>
                        <th>Total Amount</th>
                        <th style={{ borderLeft: "1px solid #fff" }}>
                          Total No.
                        </th>
                        <th>Total Amount</th>

                        {/* Sub-headers for Physical Progress */}
                        <th style={{ borderLeft: "1px solid #fff" }}>
                          Total No.
                        </th>
                        <th>Total Amt</th>
                        <th style={{ borderLeft: "1px solid #fff" }}>
                          Total No.
                        </th>
                        <th>Total Amt</th>
                        <th style={{ borderLeft: "1px solid #fff" }}>
                          Total No.
                        </th>
                        <th>Total Amt</th>

                        {/* Sub-headers for final groups */}
                        <th style={{ borderLeft: "1px solid #fff" }}>
                          Total No.
                        </th>
                        <th>Total Amount</th>
                        <th style={{ borderLeft: "1px solid #fff" }}>
                          Total No.
                        </th>
                        <th>Total Amount</th>
                      </tr>
                    </thead>

                    <tbody>
                      <>
                        {reportData.length === 0 ? (
                          <tr>
                            <td
                              colSpan={18}
                              style={{ textAlign: "center", padding: "10px" }}
                            >
                              {t("No data available")}
                            </td>
                          </tr>
                        ) : (
                          currentData.map((row, i) => (
                            <tr
                              key={i}
                              style={{
                                backgroundColor:
                                  i % 2 === 0 ? "#E5F4FB" : "#CFE4F1",
                                fontSize: "18px",
                                fontWeight: "400",
                              }}
                            >
                              <td style={{ padding: "8px 8px" }}>
                                {i + indexOfFirst + 1}
                              </td>
                              <td>{row.District}</td>
                              <td>{row.Taluka}</td>
                              <td>{row.TotalWorksCount || 0}</td>
                              <td>{row.TotalWorksAmt || 0}</td>
                              <td>{row.GRCount || 0}</td>
                              <td>{row.GRAmt || 0}</td>
                              <td>{row.TSCount || 0}</td>
                              <td>{row.TSAmt || 0}</td>
                              <td>{row.TSNoWOCount || 0}</td>
                              <td>{row.TSNoWOAmt || 0}</td>
                              <td>{row.WOCount || 0}</td>
                              <td>{row.WOAmt || 0}</td>
                              {/* Progress Columns */}
                              <td>{row.Prog30Count || 0}</td>
                              <td>{row.Prog30Amt || 0}</td>
                              <td>{row.Prog50Count || 0}</td>
                              <td>{row.Prog50Amt || 0}</td>
                              <td>{row.Prog100Count || 0}</td>
                              <td>{row.Prog100Amt || 0}</td>
                              <td>{row.PayCount || 0}</td>
                              <td>{row.PayAmt || 0}</td>
                              <td>{row.NotPayCount || 0}</td>
                              <td>{row.NotPayAmt || 0}</td>
                            </tr>
                          ))
                        )}
                      </>

                      {/* PAGE TOTAL */}
                      <tr
                        style={{
                          backgroundColor: "#f0f0f0",
                          fontWeight: "bold",
                          borderTop: "2px solid black",
                          fontSize: "18px",
                        }}
                      >
                        <td colSpan="4" style={{ textAlign: "right" }}>
                          Page Total
                        </td>

                        <td>₹ {pageTotalWorksAmt.toLocaleString("en-IN")}</td>

                        <td></td>
                        <td>₹ {pageGRAmt.toLocaleString("en-IN")}</td>

                        <td></td>
                        <td>₹ {pageTSAmt.toLocaleString("en-IN")}</td>

                        <td></td>
                        <td>₹ {pageTSNoWOAmt.toLocaleString("en-IN")}</td>

                        <td></td>
                        <td>₹ {pageWOAmt.toLocaleString("en-IN")}</td>

                        <td></td>
                        <td>₹ {pageProg30Amt.toLocaleString("en-IN")}</td>

                        <td></td>
                        <td>₹ {pageProg50Amt.toLocaleString("en-IN")}</td>

                        <td></td>
                        <td>₹ {pageProg100Amt.toLocaleString("en-IN")}</td>

                        <td></td>
                        <td>₹ {pagePayAmt.toLocaleString("en-IN")}</td>

                        <td></td>
                        <td>₹ {pageNotPayAmt.toLocaleString("en-IN")}</td>
                      </tr>

                      {/* GROSS TOTAL */}
                      <tr
                        style={{
                          backgroundColor: "#f0f0f0",
                          fontWeight: "bold",
                          borderTop: "2px solid black",
                          fontSize: "18px",
                        }}
                      >
                        <td colSpan="4" style={{ textAlign: "right" }}>
                          Gross Total
                        </td>

                        <td>₹ {grossTotalWorksAmt.toLocaleString("en-IN")}</td>

                        <td></td>
                        <td>₹ {grossGRAmt.toLocaleString("en-IN")}</td>

                        <td></td>
                        <td>₹ {grossTSAmt.toLocaleString("en-IN")}</td>

                        <td></td>
                        <td>₹ {grossTSNoWOAmt.toLocaleString("en-IN")}</td>

                        <td></td>
                        <td>₹ {grossWOAmt.toLocaleString("en-IN")}</td>

                        <td></td>
                        <td>₹ {grossProg30Amt.toLocaleString("en-IN")}</td>

                        <td></td>
                        <td>₹ {grossProg50Amt.toLocaleString("en-IN")}</td>

                        <td></td>
                        <td>₹ {grossProg100Amt.toLocaleString("en-IN")}</td>

                        <td></td>
                        <td>₹ {grossPayAmt.toLocaleString("en-IN")}</td>

                        <td></td>
                        <td>₹ {grossNotPayAmt.toLocaleString("en-IN")}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* PAGINATION */}
                <div className="col-12 mt-4 mb-2">
                  <div className="row">
                    <div className="col-6">
                      <p className="text-gray-600" style={{ fontSize: "18px" }}>
                        {t("Showing")} {indexOfFirst + 1} {t("to")}{" "}
                        {Math.min(indexOfLast, reportData.length)} {t("of")}{" "}
                        {reportData.length} {t("entries")}
                      </p>
                    </div>
                    <div
                      className="col-6"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "end",
                      }}
                    >
                      <GooglePagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}
        {loading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(255,255,255,0.4)",
              backdropFilter: "blur(2px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div className="Adminloader"></div>
          </div>
        )}
      </div>
    </>
  );
};

export default WorkStatusReport;
